import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import ComboBox from 'Components/ComboBox'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function CreateMessage({
  setMOpen,
  title = '',
  fileline = '',
  settingId = false,
  document = false,
  immobilier = false,
  vehicule = false,
  mescompte = false,
  recette = false,
  liste = false,
  project = false,
  note = false,
  contact = false,
  updateData = false,
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = React.useState(true)
  const [contactList, setContactList] = useState([])
  const [selectedReason, setSelectedReason] = useState('')
  const [object, setObject] = useState(title)
  const [message, setMessage] = useState('')
  const [file, setFile] = useState(null)

  const { handleSubmit, setValue } = useForm({
    defaultValues: {},
  })

  useEffect(() => {
    getContacts()
  }, [])

  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('file', file)
    formData.append('object', object)
    formData.append('message', message)
    formData.append('contact', data.contact.id)
    if (document) formData.append('document', document.id)
    if (settingId) formData.append('settingId', settingId)
    if (immobilier) formData.append('immobilier', immobilier.id)
    if (vehicule) formData.append('vehicule', vehicule.id)
    if (mescompte) formData.append('mescompte', mescompte.id)
    if (recette) formData.append('recette', recette.id)
    if (liste) formData.append('liste', liste.id)
    if (project) formData.append('project', project.id)
    if (note) formData.append('note', note.id)
    if (contact) formData.append('contact', contact.id)

    await makePostRequest(
      '/api/inbox/message/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (updateData) {
      updateData()
    }
    handleClose()
    // alert('Mail sent.')
    // handleClose()
  }
  const handleClose = () => {
    // console.log('sdf')
    setMOpen(false)
  }
  const getContacts = async () => {
    const response = await makeGetRequest('/api/Social/get-all-contacts/', {}, true)
    if (response.status === 200) {
      let contacts = []
      response.data.forEach((el) => {
        contacts.push({
          id: el.id,
          label: `${el.Nom} ${el.Prenom} ${el.Email}`,
          value: `${el.Email}`,
        })
      })
      setContactList(contacts)
    }
  }
  return (
    <>
      <Dialog
        open={true}
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <DialogContentText textAlign={'center'} pb={2} fontWeight={700} color={'black'}>
              Nouveau message
            </DialogContentText>
            <Box minWidth={isMobile ? '100%' : 800}>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  Contact:
                </Box>
                <Box width={'100%'}>
                  <ComboBox
                    handleAutoComplete={(e, j) => setValue('contact', j)}
                    label="Contact"
                    data={contactList}
                    name="contact"
                    required={true}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  Object:
                </Box>
                <Box width={'100%'}>
                  <TextField
                    onChange={(e) => setObject(e.target.value)}
                    fullWidth
                    required
                    value={object || ''}
                    placeholder="Object"
                    size="small"
                    sx={{ '.MuiInputBase-input': { boxShadow: 'unset' } }}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140} display={isMobile ? 'none' : 'block'}>
                  Message:
                </Box>
                <Box width={'100%'}>
                  <TextField
                    placeholder="Message"
                    onChange={(e) => setMessage(e.target.value)}
                    fullWidth
                    multiline
                    rows={10}
                    required
                    size="small"
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} mt={2}>
                <Box width={140}>Pièces jointes :</Box>
                <Box width={'100%'}>
                  <Button
                    variant="contained"
                    component="label"
                    sx={{
                      color: 'black',
                      background: 'none',
                      '&:hover': {
                        backgroundColor: '#aeaeae',
                      },
                    }}
                  >
                    <input
                      name="file"
                      type="file"
                      style={{ width: 300 }}
                      //   filename={file}
                      // accept="application/pdf"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </Button>
                </Box>
              </Box>
              {document && <Box mt={2}>{document.Lien.split('/').pop()}</Box>}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Envoyer</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
